import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Services
import { NavigationParam, RouteParam, ServiceBase } from '../service-base';

const CLASS_NAME = 'Settlement';
const ENDPOINT = `/settlements/`;
const NAVIGATIONS: NavigationParam[] = [];
const ROUTES: RouteParam[] = [
    { key: 'group', path: 'group/' },
];

@Injectable({
    providedIn: 'root'
})
export class SettlementService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addNavigations(NAVIGATIONS);
        this.addRoutes(ROUTES);
    }

    public createGroupedSettlements$(settlements: any[]): Observable<any> {
        return this.createBulk$(settlements, {
            url: this.routes.group
        });
    }
}